import Icon from "@vfuk/core-icon";
import { useNavigate } from "react-router-dom";
import {
  RoundedPillStyles,
  ProductsListStyles,
  TableRow,
  Tooltip,
  PillState,
} from "@ucchub/ui";
import Pill from "@vfuk/core-pill";
import Link from "@vfuk/core-link";
import {
  CustomerListItem,
  OrganisationStatus,
  CustomerDetails,
} from "@components/customer/Customer.types";
import { STATUS_TRANSLATE_KEYS } from "@components/customer/CustomerDetails";
import { useTranslation } from "react-i18next";

type CustomerRowProps = {
  customer: CustomerListItem;
};

const STATUS_STATE: { [k in CustomerDetails["status"]]: PillState } = {
  [OrganisationStatus.ACTIVE]: "success",
  [OrganisationStatus.DRAFT]: "submitted",
  [OrganisationStatus.INACTIVE]: "warn",
};

const CustomersRow = ({ customer }: CustomerRowProps): JSX.Element => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const statusState = (customer.status &&
    STATUS_STATE[customer.status]) as PillState;

  const statusTxt = customer.status
    ? t(`core:customers:${STATUS_TRANSLATE_KEYS[customer.status]}`)
    : "";

  const viewLink =
    customer.status === OrganisationStatus.DRAFT
      ? "/customers/" + customer.id + "/draft"
      : "/customers/" + customer.id + "/view";

  return (
    <TableRow
      rowData={[
        customer.name,
        customer.country || "__",
        <RoundedPillStyles state={statusState} key={customer.id + "-status"}>
          <Pill text={statusTxt} />
        </RoundedPillStyles>,
        <div key={customer.id + "-product"}>
          {customer.products?.map(
            (product, index) =>
              index < 3 && (
                <ProductsListStyles key={product.id}>
                  {product.name}
                </ProductsListStyles>
              )
          )}
          {customer.products && customer.products?.length > 3 && (
            <Link
              text={"+ " + (customer.products?.length - 3) + " more"}
              showUnderline={true}
            />
          )}

          {!customer.products || (customer.products?.length === 0 && "__")}
        </div>,
      ]}
      canViewIcon={true}
      onIconClick={() => navigate(viewLink)}
      isIconDisabled={false}
      icon={
        <Tooltip content={t("core:customers:view")}>
          <span>
            <Icon name={"chevron-right"} appearance="secondary" size={3} />
          </span>
        </Tooltip>
      }
    />
  );
};

export default CustomersRow;
